import { ApiError, apiFetch } from './client';
export async function getViewerSettings() {
    try {
        return await apiFetch('/viewer-settings');
    }
    catch (error) {
        if (error instanceof ApiError && error.status === 404) {
            return null;
        }
        throw error;
    }
}
export async function putViewerSettings(settings) {
    return apiFetch('/viewer-settings', {
        method: 'PUT',
        body: JSON.stringify({ settings }),
    });
}
